// extracted by mini-css-extract-plugin
export default {"container":"ValidationChecker_container__KCYfG"};